import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetMyInvitationsQuery = (refetch = false) => {
  const { teamController } = useAvApi();

  return useQuery({
    queryKey: ['my-invitations'],
    queryFn: async () => {
      const { data } = await teamController.getV2TeamsInvited();

      return data;
    },
    refetchInterval: refetch ? 30000 : 0,
  });
};
